import { handlerGetUrlParams } from '@/utils/dealUrlParams'
import request from '@/utils/request'

// export function getCollectList(data) {
//     return request({
//         url: `/bus/collect/list?${data}`,
//         method: 'GET',

//     })
// }

export function getCollectList(param) {
  const url = handlerGetUrlParams('/bus/collect/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 取消收藏
export function deleteCollectList(ids) {
  return request({
    url: `/bus/collect/${ids}`,
    method: 'DELETE'
  })
}
